import {Component, OnDestroy, OnInit} from '@angular/core';
import {LoadingService} from '../../services/loading.service';
import {Subscription} from 'rxjs';

@Component({
    selector: 'app-loading',
    templateUrl: './loading.component.html',
    styleUrl: './loading.component.css',
    standalone: false
})
export class LoadingComponent implements OnInit, OnDestroy {
  loading = false;
  private subscription: Subscription = new Subscription();

  constructor(private loadingService: LoadingService) {}

  ngOnInit(): void {
    this.subscription = this.loadingService.loading$.subscribe(
      isLoading => this.loading = isLoading
    );
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
